<template lang="pug">
article.vue-page-story-show-root
  CommunityQPublishModal
  StoryEmailModal
  AuditHistoryModal(:story-id="storyId")

  nav.story-header.container(data-spy="affix" data-offset-top="95")
    .row
      .col-md-6
        h1 {{ name }}

      .col-md-6.text-right
        .btn-group
          a.btn.btn-prominent.btn-info(@click="goBack()")
            i.fa.fa-arrow-left
            |
            | Back

          EditButton(:story-id="storyId" :hide-label="false" :disabled="editDisabled" :disabled-reason="editDisabledReason")
          HistoryButton(v-if="canViewAudit" :story-id="storyId" :hide-label="false")
          ExportButton(v-if="canEditField('export_format_ids')" :story-id="storyId" :story-name="name" :hide-label="false")
          DuplicateButton(
            v-if="canEditField('user_id')"
            :story-id="storyId"
            :story-name="name"
          )

          template(v-if="!spiked && canEditField('user_id')")
            DeleteButton(
              :story-id="storyId"
              :story-name="name"
              @deleted="goBack"
            )

    .row
      .col-md-6
        p.server-path(v-if="canEditField('file_mode')")
          i.fa.fa-hdd-o
          |
          |
          a(v-if="open_folder_url" :href="open_folder_url")
            | {{ content_path }}
          span(v-else)
            | {{ content_path }}
      .col-md-6.text-right
        p.updated-at(title='Last modified')
          i.fa.fa-clock-o
          |
          | {{ lastUpdated }}

  .row
    .col-md-7
      LabelledValue(label="Slug" :value="slug")

      LabelledValue(v-if="canEditField('overline')" label="Overline" :value="overline")

      LabelledValue(label="Headline" :value="headline")

      LabelledValue(v-if="canEditField('drop_head')" label="Deck head" :value="drop_head")

      LabelledValue(label="Byline" :value="byline" :html="true")

      LabelledValue(label="Content" :value="content" :multi-line="true" :html="true")

      LabelledValue(v-if="canEditField('endnote')" label="Endnote" :value="endnote" :multi-line="true" :html="true")

      .panel.panel-default(v-show="showInfobox && canEditField('infobox_headline')")
        .panel-heading
          h4
            | Breakout box
            |
            |
            i.fa.fa-angle-down
        .panel-body
          LabelledValue(label="Headline" :value="infobox_headline")
          LabelledValue(label="Text" :value="infobox_text" :multi-line="true" :html="true")

      .panel.panel-default(v-show="showPullQuote && canEditField('pull_quote_attributes')")
        .panel-heading
          h4
            | Pull Quotes
            |
            |
            i.fa.fa-angle-down
        .panel-body
          LabelledValue(label="Headline" :value="pullQuote.headline")
          LabelledValue(label="Quote" :value="pullQuote.quote" :multi-line="true")
          LabelledValue(label="Attribution" :value="pullQuote.attribution")

      .panel.panel-default(v-show="showCommunityQ && canEditField('featured')")
        .panel-heading
          h4
            | Web
            |
            |
            i.fa.fa-angle-down
        .panel-body
          LabelledCheckbox(label="Featured" :value="featured")
          LabelledCheckbox(label="Free" :value="ispublic")
          LabelledCheckbox(label="Comments disabled" :value="comments_disabled")
          LabelledValue(label="Headline" :value="web_head")
          LabelledValue(label="Slug" :value="web_slug")
          LabelledValue(label="Summary" :value="web_summary" :multi-line="true" :html="true")
          LabelledValue(label="Body" :value="web_body" :multi-line="true" :html="true")
          LabelledValue(label="Keywords" :value="keywords")
          Publication(v-for="storyPub in Object.values(storyPublications)" :key="storyPub.id" :story-publication="storyPub")

    #media.col-md-5
      MediaIndex(:story-id="storyId" :read-only="true")

      hr

      .row(v-if="canEditField('squeue_id')")
        .col-md-6(v-if="canEditField('squeue_id')")
          LabelledValue(label="Status queue" :value="squeueTitle")

        .col-md-6(v-if="canEditField('pub_date')")
          LabelledValue(label="Pub date" :value="pub_date")

        .col-md-6(v-if="canEditField('section_ids')")
          LabelledValue(label="Print sections" :value="sectionTitles.join(', ')")

        .col-md-6(v-if="canEditField('user_id')")
          LabelledValue(label="Owner" :value="userName")

        .col-md-6(v-if="canEditField('web_category_ids')")
          LabelledValue(label="Web categories" :value="webCategoryTitles.join(', ')")

      template(v-if="storyPlacements.length > 0 && canEditField('issue_ids')")
        hr

        Label(text="Issues")
        ul.list-group
          Placement(
            v-for="placement in storyPlacements"
            :placement="placement"
            :key="placement.id"
          )

      hr(v-if="canEditField('file_mode')")

      Label(v-if="canEditField('file_mode')" text="File storage locations")
      pre(v-if="canEditField('file_mode')" v-for="path in [content_path].concat(customFoldersStore.allPaths)" :key="path")
        i.fa.fa-hdd-o
        | &nbsp;{{ path }}

      hr(v-if="canEditField('location_ids')")
      Label(v-if="canEditField('location_ids')" text="Web Map locations")
      Locations(v-if="canEditField('location_ids')" :story-id="storyId" :read-only="true")

      hr(v-if="canEditField('notes')")

      LabelledValue(v-if="canEditField('notes')" label="Notes" :value="notes" :multi-line="true")

      template(v-if="currentUserStore.currentUser.show_advert_fields && canEditField('twitter_feed')")
        hr

        LabelledCheckbox(label="Twitter feed" :value="twitter_feed")
        LabelledCheckbox(label="Tweet" :value="tweet")
        LabelledCheckbox(label="Google Search Ad" :value="google_search_ad")
        LabelledCheckbox(label="Outbrain Ad" :value="outbrain_ad")

      hr(v-if="canEditField('export_format_ids')")

      LabelledValue(v-if="canEditField('export_format_ids')" label="Export fields" :value="exportFormatNames")

      CustomExportFields(v-if="canEditField('story_custom_fields_attributes')" :story-id="storyId")
</template>

<script>
  import { sync } from 'vuex-pathify';
  import { mapGetters } from 'vuex';
  import { mapStores, mapState } from 'pinia'
  import { useCurrentUserStore } from '@/stores/current_user.js'
  import { useCustomFoldersStore } from '@/stores/custom_folders.js'
  import { useExportFormatsStore } from '@/stores/export_formats.js'
  import { useStoryAuditsStore } from '@/stores/story_audits.js'
  import { useStoryCustomFieldsStore } from '@/stores/story_custom_fields.js'
  import { useWebCategoriesStore } from '@/stores/web_categories'
  import { useSectionsStore } from '@/stores/sections'
  import { useSqueuesStore } from '@/stores/squeues'
  import { useStoryPlacementsStore } from '@/stores/story_placements'
  import { useUsersStore } from '@/stores/users'
  import AuditHistoryModal from '@/components/stories/audit_history_modal.vue'
  import CustomExportFields from '@/components/stories/show/custom_export_fields.vue'
  import EditButton from '@/components/stories/actions/edit_button.vue';
  import ExportButton from '@/components/stories/actions/export_button.vue';
  import DeleteButton from '@/components/stories/actions/delete_button.vue';
  import DuplicateButton from '@/components/stories/actions/duplicate_button.vue';
  import HistoryButton from '@/components/stories/actions/history_button.vue';
  import Label from '@/components/shared/label.vue';
  import Value from '@/components/shared/value.vue';
  import LabelledValue from '@/components/shared/labelled_value.vue';
  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue';
  import Locations from '@/components/stories/form/locations/index.vue'
  import MediaIndex from '@/components/stories/form/media/index.vue'
  import Placement from '@/components/stories/placement/index.vue';
  import Publication from './publication.vue'
  import CommunityQPublishModal from '@/components/community_q/publish_modal.vue';
  import StoryEmailModal from '@/components/stories/email_modal.vue'
  import { storyRoute } from '@/utils/route_helpers.js'
  import { formatDateTime } from '@/utils/time_helpers.js'

  export default {
    components: {
      AuditHistoryModal,
      CustomExportFields,
      EditButton,
      ExportButton,
      DeleteButton,
      DuplicateButton,
      HistoryButton,
      Label,
      Value,
      LabelledCheckbox,
      LabelledValue,
      Locations,
      MediaIndex,
      Placement,
      Publication,
      CommunityQPublishModal,
      StoryEmailModal
    },

    props: {
      storyId: {
        type: Number,
        required: true
      },
      issueId: {
        type: Number,
        required: false
      },
      pageId: {
        type: Number,
        required: false
      }
    },

    computed: {
      ...sync('story/*'),
      spiked: sync('story@spiked'),
      storyPublications: sync('storyPublications/storyPublications'),
      pullQuote: sync('pullQuote'),
      ...mapGetters('storyMedia', { storyMedia: 'attachments' }),
      ...mapStores(
        useCurrentUserStore,
        useCustomFoldersStore,
        useExportFormatsStore,
        useSectionsStore,
        useStoryAuditsStore,
        useSqueuesStore,
        useStoryCustomFieldsStore,
        useUsersStore,
        useWebCategoriesStore
      ),
      ...mapState(useStoryPlacementsStore, ['storyPlacements']),

      // Check if user can view audit history (non-limited roles)
      canViewAudit() {
        const user = this.currentUserStore.currentUser
        return user && user.can_audit_stories
      },

      exportFormatNames() {
        const formats = this.exportFormatsStore.forIds(this.export_format_ids)

        return formats.map(format => format.name).join(', ')
      },

      name() {
        return this.headline ? this.headline : this.slug;
      },

      squeueTitle() {
        return this.squeuesStore.forId(this.squeue_id)?.title
      },

      sectionTitles() {
        return this.sectionsStore.forIds(this.section_ids).map(section => section.title)
      },

      userName() {
        return this.usersStore.forId(this.user_id)?.name
      },

      webCategoryTitles() {
        return this.webCategoriesStore.forIds(this.web_category_ids).map(({ title }) => title)
      },

      showCommunityQ() {
        return !!(
          this.web_head ||
          this.web_summary ||
          this.web_body ||
          this.web_category_ids.length > 0 ||
          this.keywords
        );
      },

      showInfobox() {
        return this.infobox_headline || this.infobox_text;
      },

      showPullQuote() {
        const { headline, quote, attribution } = this.pullQuote;

        return headline || quote || attribution;
      },

      lastUpdated() {
        return formatDateTime(this.updated_at);
      },

      // Get list of editable fields for the current user from the backend
      editableFields() {
        return this.currentUserStore.currentUser?.editable_story_fields || [];
      },

      // Check if edit should be disabled based on backend can_edit flag
      editDisabled() {
        return !this.can_edit
      },

      // Reason message for disabled edit button
      editDisabledReason() {
        return this.editDisabled ? 'You do not have permission to edit this story' : 'Edit'
      }
    },

    async mounted() {
      const id = this.storyId

      await this.$store.dispatch('story/fetch', { id: this.storyId })
      await this.$store.dispatch('story/fetchDependentData')
    },

    methods: {
      // Check if user can edit a specific field
      // This is policy-driven, not role-based
      canEditField(fieldName) {
        return this.editableFields.includes(fieldName);
      },

      goBack() {
        this.$router.push(storyRoute({
          storyRoute: 'stories',
          issueRoute: 'issue',
          pageRoute: 'issuePage',
          router: this.$router
        }))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-group {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-left: auto;

    // Ensure button components display inline
    :deep(> *) {
      display: inline-block;
    }
  }
</style>
